var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatsticker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.12577C10.833 4.22219 10.4223 3.38143 9.81222 2.69432C9.20213 2.00722 8.41587 1.4999 7.5384 1.22718C6.66093 0.954468 5.72562 0.926728 4.83353 1.14696C3.94144 1.36719 3.1265 1.82702 2.47676 2.47676C1.82702 3.1265 1.36719 3.94144 1.14696 4.83353C0.926728 5.72562 0.954468 6.66093 1.22718 7.5384C1.4999 8.41587 2.00722 9.20213 2.69432 9.81222C3.38143 10.4223 4.22219 10.833 5.12577 11L11 5.12577Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9995 5.12577C10.1949 4.97303 9.3652 5.01925 8.58254 5.2604C7.79989 5.50156 7.08804 5.93034 6.50895 6.50943C5.92985 7.08853 5.50107 7.80038 5.25991 8.58303C5.01876 9.36568 4.97254 10.1954 5.12529 11",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatsticker);
export default __webpack_public_path__ + "static/media/chatsticker.fce7889d69196f1e7ad2c436df376891.svg";
export { ForwardRef as ReactComponent };